export type IViewReadonlyChild = ($button: IjQueryElm) => void;

export function viewReadonlyChild($button: IjQueryElm) {
  window.DexeroCoreApp.animateButton($button);
  window.DexeroCoreApp._saveFormViaAjax($button.closest('form') as JQuery<HTMLFormElement>)
    .done(() => {
      window.DexeroCoreApp.appendCurrentUrlBeforeRedirect($button as JQuery<HTMLAnchorElement>);
    })
    .fail(() => {
      window.DexeroCoreApp.animateButton($button);
    });
}
